<template>
    <div id="facilitador">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex xs12 >
            <h4 class="grey--text text--darken-1">
              <v-icon small color="primary">drag_indicator</v-icon> Sede Central
            </h4>
          </v-flex>
        </v-layout>
        <v-card>
          <v-card-title class="headline lighten-3">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
            >
            </v-text-field>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :loading="loading"
            :items="subcentros"
            class="elevation-1"
            rows-per-page-text="Filas por página"
            no-data-text="No existen registros"
            no-results-text="Sin resultados"
            page-text="de"
            :rows-per-page-items="[10, 25, 50, 100, {'text': 'Todos', value: -1}]"
            v-bind:search="search"
            v-cloak
          >
            <template v-slot:items="props">
              <td>{{ props.index + 1 }}</td>
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.institucioneducativa }}</td>
              <td>{{ props.item.nro_resolucion }}</td>
              <td>{{ props.item.fecha_creacion | formatdate }}</td>
              <td>
                <span v-if="props.item.estadoinstitucion_tipo_id == 10"><v-chip small color="success lighten-2">abierto</v-chip></span>
                <span v-else-if="props.item.estadoinstitucion_tipo_id == 19"><v-chip small color="warning lighten-2">cerrado</v-chip></span>
                <span v-else><v-chip small color="warning lighten-2">regulación</v-chip></span>
              </td>
              <td>
                <v-tooltip bottom>
                  <template v-slot:activator="{on}">
                    <v-btn
                      v-on="on"
                      dark
                      icon
                      small
                      depressed
                      color="primary"
                      @click="showDetail(props.item.id)"
                    >
                      <v-icon small>assignment</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver detalle</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{on}">
                    <v-btn
                      v-on="on"
                      dark
                      icon
                      small
                      depressed
                      color="success"
                      @click="showDatos(props.item.id)"
                    >
                      <v-icon small>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar información</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-container>
      <v-dialog
        v-model="dialogDetail"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        scrollable
      >
        <detalle-centro :mcentro="centro" :mcursos="cursos" :mcodigo="codigo_centro" :minfor="infor" :mloading="loadingDetail" @close="dialogDetail = false"></detalle-centro>
      </v-dialog>
      <!--datos para edicion neko-->
      <v-dialog
        v-model="neko"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        scrollable
      >
        <datos-sede-subsede :mcentro="centro" :mcodigo="codigo_centro"  :minfor="infor"  :mloading="loadingDetail2" @close="neko = false"></datos-sede-subsede>
      </v-dialog>

      <v-snackbar
        v-model="snack.state"
        top
        right
        :timeout="2500"
        :color="snack.color"
        :multi-line="snack.mode === 'multi-line'"
      >
        {{ snack.text }}
      </v-snackbar>
    </div>
  </template>
  <script>
  /* eslint-disable no-console */
  import Service from "../services/general";
  import axios from "axios";
  import DetalleCentro from '@/components/DetalleCentro';
  import DatosSedeSubsede from '@/components/DatosSedeSubsede'; //neko
  export default {
    name: "facilitador",
    components: {
      DetalleCentro,
      DatosSedeSubsede
    },
    data() {
      return {
        search: "",
        headers: [
          { text: "Nro", align: "left", sortable: false },
          { text: "Código ", value: "id" },
          { text: "Centro de Capacitación ", value: "institucioneducativa" },
          { text: "Número Resolución ", value: "nro_resolucion" },
          { text: "Fecha de Creación ", value: "fecha_creacion" },
          { text: "Estado ", value: "estadoinstitucion_tipo_id" },
          { text: "Acciones", sortable: false, width: "140px" }
        ],
        loading: false,
        subcentros: [],
        centro: {
          jurisdiccion_geografica: {}
        },
        infor: [],
        codigo_centro: '',
        dialogDetail: false,
        neko: false,
        loadingDetail: false,
        loadingDetail2: false,
        loadingCurso: false,
        size_width: 0,
        dparams: {},
        snack: {
          state: false,
          color: 'success',
          mode: '',
          text: ''
        }
      };
    },
    mounted() {
      this.dparams = Service.getParams();
      if (this.dparams && this.dparams.roluser != Service.rol().director) {
        this.$router.push({name: 'principal'});
      }
      if (this.dparams != null) {
        this.getSedeCentral();
      }
      this.$nextTick(() => {
        window.addEventListener("resize", this.getWidth);
        this.getWidth();
      });
    },
    methods: {
      getWidth() {
        this.size_width = document.documentElement.clientWidth;
      },
      getSedeCentral() {
        this.loading = true; 
        axios
          .get(Service.getBase() + 'lista/sedecentral/' + this.dparams.ie_id, Service.getHeader())
          .then(response => {
            this.loading = false;
            this.subcentros = response.data;
          })
          .catch(error => {
            this.loading = false;
            console.error("Error al cargar registros", error);
          });
      },
      showDetail(codigo) { 
        this.codigo_centro = codigo;
        this.dialogDetail = true;
        this.loadingDetail = true;
        Service.detalleCentro(codigo).then(response => { 
          this.centro = response.data.centro; 
          this.cursos = response.data.cursos;
          this.infor = response.data.infor;
          this.loadingDetail = false;
          this.drowMap(this.centro.jurisdiccion_geografica.cordy, this.centro.jurisdiccion_geografica.cordx, this.centro.institucioneducativa);
        }).catch(error => {
          this.loadingDetail = false;
          console.error('Error al cargar datos', error);
        });
      },
      showDatos(codigo) { 
        this.codigo_centro = codigo;
        this.neko = true;
        this.loadingDetail2 = true;
        Service.updateSedeSubsede(codigo).then(response => {
          this.centro = response.data.centro; 
          this.infor = response.data.infor;
          this.loadingDetail2 = false;
          
        }).catch(error => {
          this.loadingDetail2 = false;
          console.error('Error al cargar datos', error);
        });  
      },
      
      toast(color, text) {
        this.snack.color = color;
        this.snack.text = text;
        this.snack.state = true;
      },
      beforeDestroy() {
        window.removeEventListener("resize", this.getWidth);
      }
    }
  };
  </script>